import React from 'react';
import EntertainmentRedJewel from '../assets/EntertainmentRedJewel.png';
import SocialBlueSapphire from '../assets/SocialBlueSapphire.png';
import AITurquoiseJewel from '../assets/AITurquoiseJewel.png';
import FinanceGreenJewel from '../assets/FinanceGreenJewel.png';
import GamingOrangeJewel from '../assets/GamingOrangeJewel.png';
import ShoppingPurpleJewel from '../assets/ShoppingPurpleJewel.png';
import ToolsBrownJewel from '../assets/ToolsBrownJewel.png';
import LearningGrayJewel from '../assets/LearningGrayJewel.png';
import KidsJewel from '../assets/KidsJewel.png';
import { Link } from 'react-router-dom';

export const Home = () => {

    const ecosystemArray = [
        {
            color: "#002fdd",
            ribbion: "Social",
            description: 'BlockStar Social is the place to connect with family and friends and for meeting new people, chatting, and sharing life’s updates. Join from anywhere, bring your stories, start a conversation, and be part of a thriving global community.',
            link: "/social",
            img: SocialBlueSapphire,
            externallink: false
        },
        {
            color: "#c30101",
            ribbion: "Entertainment",
            description:
                "BlockStar Entertainment offers a wide range of videos, music, podcasts, and TV shows. It's a great source for decentralized entertainment, with something for everyone, and you can access it anytime, anywhere.",
            link: "/entertainment",
            img: EntertainmentRedJewel,
            externallink: false
        },
        {
            color: "#0ec1e1",
            ribbion: "AI",
            description:
                "BlockStar AI is your gateway to incorporating artificial intelligence into your everyday life. With user-friendly systems, BlockStar brings together tools designed for productivity, creativity, learning, and entertainment, all enhanced by AI.",
            link: "/ai",
            img: AITurquoiseJewel,
            externallink: false
        },
        {
            color: "#00a94d",
            ribbion: "Finance",
            description:
                'BlockStar Finance is the premier online destination for digital asset management providing a simple interface for trading crypto, staking, and real-time analytics. BlockStar is decentralized so your digital assets always remain in your control.',
            link: "/finance",
            img: FinanceGreenJewel,
            externallink: false
        },
        {
            color: "#b05700",
            ribbion: "Gaming",
            description:
                "Step into the realm of BlockStar Gaming and discover a dynamic playground for blockchain-based games. Whether you're looking for strategic challenges, pure enjoyment, or the thrill of rewards, you'll find a game that suits your style.",
            link: "/gaming",
            img: GamingOrangeJewel,
            externallink: false
        },
        {
            color: "#b839ff",
            ribbion: "Shopping",
            description:
                "Explore BlockStar Shopping for high quality goods crafted with the latest fashion, tech and lifestyle trends, all in one place. BlockStar Shopping features an extensive selection of quality products, services, and hard to find collectibles.",
            link: "/shopping",
            img: ShoppingPurpleJewel,
            externallink: false
        },
        {
            color: "#7a1824",
            ribbion: "Tools",
            description:
                'BlockStar Tools optimizes business through collaboration, video conferencing, and groundbreaking simultaneous cross-platform streaming capabilities. Unparalleled blockchain-based solutions enable complete customer and data management.',
            link: "/tools",
            img: ToolsBrownJewel,
            externallink: false
        },
        {
            color: "#6f767e",
            ribbion: "Learning",
            description:
                'Expand your knowledge with BlockStar Learning. We offer a wide variety of courses, including college credit opportunities. Dive into our large repository of educational materials, and follow a learning path aligned with your interests and goals.',
            link: "/learning",
            img: LearningGrayJewel,
            externallink: false
        },

        {
            color: "#fce628",
            ribbion: "Kids",
            description: 'Dive into BlockStar Kids, a safe space to discover and explore. Engage with interactive games, absorb new knowledge, and create with AI - all within a trusted blockchain framework.',
            link: "/kids",
            img: KidsJewel,
            externallink: false
        },
    ];

    return (
        <div className="container my-5">
            <div className="row g-4">
                {ecosystemArray.map((item, index) => (

                    <Link to={item.link} className="col-md-4" key={index}>

                        <div className="card custom-card position-relative" style={{ height: '350px', border: `1px solid ${item.color}` }}>
                            <div class="ribbon ribbon-index ribbon-top-left ribbon-top-left-index"><span style={{ backgroundColor: item.color }}></span></div>
                          
                            <img
                                src={item.img}
                                className="card-img-top"
                                alt={item.ribbon}
                                style={{ height: '200px', objectFit: 'contain' }}
                            />
                            <div className="card-body text-center">
                                <p className="card-text">{item.description}</p>
                            </div>
                        </div>

                    </Link>

                ))}
            </div>
        </div>
    );
}
